import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function MidCTA() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="py-0 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6081a850f74654b63d68be6e96607b55.jpg"
          alt="Schedule chimney and air duct cleaning Jacksonville FL"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-dark/92 via-brand-dark/80 to-brand-dark/60" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/40 via-transparent to-transparent" />
      </div>

      <div className="relative py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div
            ref={ref}
            className={`flex flex-col lg:flex-row items-center justify-between gap-12 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            {/* Left: Text */}
            <div className="lg:w-7/12">
              <div className="inline-flex items-center gap-2 bg-brand-amber/20 border border-brand-amber/35 text-amber-300 text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-6">
                <div className="w-1.5 h-1.5 bg-amber-400 rounded-full animate-pulse" />
                Same-Week Appointments Available
              </div>

              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
                Don't Wait Until<br />
                <span className="text-brand-amber">It Becomes a Hazard.</span>
              </h2>

              <p className="text-white/70 text-lg leading-relaxed mb-8 max-w-xl">
                Dirty chimneys cause house fires. Clogged dryer vents are a leading cause of home fires. Poor air quality affects your family every single day. One call to BBM Services takes care of all three — fast, affordable, and done right.
              </p>

              {/* Proof points */}
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                {[
                  { num: '2,900+', text: 'Chimney fires annually — most preventable', icon: 'ri-fire-fill' },
                  { num: '#1', text: 'Cause of dryer fires: clogged vents', icon: 'ri-alert-fill' },
                  { num: '5x', text: 'Indoor air can be more polluted than outdoor', icon: 'ri-lungs-line' },
                ].map((proof) => (
                  <div key={proof.text} className="p-4 bg-white/8 backdrop-blur-sm border border-white/12 rounded-2xl">
                    <div className="w-8 h-8 flex items-center justify-center mb-2">
                      <i className={`${proof.icon} text-brand-amber text-lg`} />
                    </div>
                    <div className="font-serif text-2xl font-bold text-brand-amber mb-1">{proof.num}</div>
                    <div className="text-white/55 text-xs leading-relaxed">{proof.text}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right: CTA Card */}
            <div className="lg:w-4/12 w-full">
              <div className="bg-white rounded-3xl p-8">
                <h3 className="font-serif text-2xl font-bold text-brand-dark mb-2">Ready to Book?</h3>
                <p className="text-brand-warm-gray text-sm mb-6">Get your free quote today — we respond within the hour.</p>

                <div className="space-y-3 mb-6">
                  {[
                    'Free quote, no obligation',
                    'Same-week scheduling',
                    'Certified, insured technicians',
                    'Before & after documentation',
                  ].map((item) => (
                    <div key={item} className="flex items-center gap-2.5 text-sm text-brand-light">
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-double-fill text-brand-amber" />
                      </div>
                      {item}
                    </div>
                  ))}
                </div>

                <Link
                  to="/contact"
                  className="w-full bg-brand-amber hover:bg-brand-amber-dark text-white font-bold py-4 px-6 rounded-xl text-base transition-all cursor-pointer whitespace-nowrap block text-center mb-3"
                >
                  Get a Free Quote
                </Link>
                <a
                  href="tel:+19045550191"
                  className="w-full border-2 border-stone-200 hover:border-brand-amber text-brand-dark hover:text-brand-amber font-semibold py-3.5 px-6 rounded-xl text-sm transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-phone-fill" />
                  </div>
                  Call (904) 555-0191
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
